import React  from 'react';
import './App.css';
import BatteryLang from './BatteryLang.json';
import { useNavigate } from "react-router-dom";

import BatteryLogAllToolbar from './BatteryLogAllToolbar.js';

class BatteryLogAll extends React.Component {

	constructor(props) {

		super(props);
		
		this.state = {
			logListJsonObj: null,
			index: 0,
			count: 10,
		};

		this.serverGetLogList = this.serverGetLogList.bind(this);
		this.handleSelectLog = this.handleSelectLog.bind(this);
		this.handlePrev = this.handlePrev.bind(this);
		this.handleNext = this.handleNext.bind(this);	
		this.renderOneLog = this.renderOneLog.bind(this);
		this.renderAllLogs = this.renderAllLogs.bind(this);
		this.renderResults = this.renderResults.bind(this);
	}
	
	componentDidMount() {
		this.serverGetLogList(0);
	}

	async serverGetLogList(index) {
		
		var batteryID = 0;
		
		var companyID = this.props.companyID;
		var baseURLAPI = this.props.baseURLAPI;
		var url = baseURLAPI + "/getbatteryloglist?batteryid=" + batteryID;
		url = url + "&companyid=" + companyID;
		url = url + "&sortby=batteryLogID&sortasc=0";
		url = url + "&index=" + index + "&count=" + this.state.count;
		console.log(url);
		
		const res = await fetch(url);
		const jsonObj = await res.json();

		this.setState({
			logListJsonObj: jsonObj,
		});
	}
		
	handleSelectLog(batteryLogID) {
		this.props.setBatteryLogID(batteryLogID);
		const navigate = this.props.navigate;
  		navigate("/batterylog");
	}

	handlePrev() {
		var index = this.state.index - 10;
		this.setState({index: index});
		this.serverGetLogList(index);
	}

	handleNext() {
		var index = this.state.index + 10;
		this.setState({index: index});
		this.serverGetLogList(index);
	}

	renderOneLog(itemObj) {
		
		var batteryLogID = itemObj.batteryLogID;
		var batteryName = itemObj.batteryName;		
		var operation = itemObj.operation;		
		var unixTimeSec = itemObj.unixTimeSec;
		var uploadedUnixTimeSec = itemObj.uploadedUnixTimeSec;
		var durationSec = itemObj.durationSec;
		
		var unixTimeString = this.props.getDateTimeStringFromUnixTimeSec(unixTimeSec);
		var uploadedDateTimeString = this.props.getDateTimeStringFromUnixTimeSec(uploadedUnixTimeSec);
		var durationSecString = this.props.getTimeStringFromSeconds(durationSec);
		
		var operationString = operation;

		return (
			<tr key={batteryLogID}>
				<td
					className="BatteryLogListItemBatteryLogID"
					onClick={() => this.handleSelectLog(batteryLogID)}
				>
					{batteryLogID}
				</td>
				<td
					className="BatteryLogListItemBatteryName"
					onClick={() => this.handleSelectLog(batteryLogID)}
				>
					{batteryName}
				</td>				
				<td
					className="BatteryLogListItemOperation"
					onClick={() => this.handleSelectLog(batteryLogID)}
				>
					{operationString}
				</td>				
				<td
					className="BatteryLogListItemLogStarted"
					onClick={() => this.handleSelectLog(batteryLogID)}
				>
					{unixTimeString}
				</td>
				<td
					className="BatteryLogListItemUploadedTimestamp"
					onClick={() => this.handleSelectLog(batteryLogID)}
				>
					{uploadedDateTimeString}
				</td>
				<td
					className="BatteryLogListItemDuration"
					onClick={() => this.handleSelectLog(batteryLogID)}
				>
					{durationSecString}
				</td>
			</tr>
		);
	}

	renderAllLogs() {

		var i;
		var logListJsonObj = this.state.logListJsonObj;
		var itemObj;
		var jsxArray = [];

		for(i=0; i<logListJsonObj.length; i++) {
			itemObj = logListJsonObj[i];
			jsxArray.push(this.renderOneLog(itemObj));
		}

		return (
			<table className="ListContainer2">
				<tbody>
					<tr>
						<td className="BatteryLogListHeaderBatteryLogID">{this.props.getLang(BatteryLang, "logID")}</td>
						<td className="BatteryLogListHeaderBatteryName">{this.props.getLang(BatteryLang, "battery")}</td>
						<td className="BatteryLogListHeaderOperation">{this.props.getLang(BatteryLang, "operation")}</td>
						<td className="BatteryLogListHeaderLogStarted">{this.props.getLang(BatteryLang, "logStarted")}</td>
						<td className="BatteryLogListHeaderUploadedTime">{this.props.getLang(BatteryLang, "uploadedTime")}</td>
						<td className="BatteryLogListHeaderDuration">{this.props.getLang(BatteryLang, "duration")}</td>
					</tr>
					{jsxArray}
				</tbody>
			</table>
		);
	}
	
	renderResults() {

		var logCount = 0;
		var logListJsonObj = this.state.logListJsonObj;
		
		if (logListJsonObj !== null) {
			logCount = logListJsonObj.length;
		}
		if (logCount === 0) {
			return (<div>No logs found</div>);
		}

		var prevYN = false;
		var nextYN = false;
		
		if (this.state.index > 0) {
			prevYN = true;
		}
		
		if (logCount === this.state.count) {
			nextYN = true;
		}

		return (
			<div>
				{this.renderAllLogs()}
				<div style={{height:"30px"}}></div>
				<div className="ListContainer3">
					{prevYN && (<div 
						className="ListPrevNextLink"
						onClick={() => this.handlePrev()}
					>
						&lt;&lt; Previous
					</div>)}
					{!prevYN && (<div 
						className="ListPrevNextLinkDisabled"
					>
						&lt;&lt; Previous
					</div>)}
					<div className="ListPrevNextLinkDisabled">|</div>
					{nextYN && (<div 
						className="ListPrevNextLink"
						onClick={() => this.handleNext()}
					>
						Next &gt;&gt;
					</div>)}
					{!nextYN && (<div 
						className="ListPrevNextLinkDisabled"
					>
						Next &gt;&gt;
					</div>)}
				</div>
			</div>
		);
	}

	render() {		

		return (
			<div>
				<BatteryLogAllToolbar
					baseURLAPI={this.props.baseURLAPI}
					companyName={this.props.companyName}
					getLang={this.props.getLang}
				/>
				<div style={{height: "20px"}}></div>
				{this.renderResults()}
			</div>
		);
	}
}

export default function BatteryLogAllFunction(props) {
	const navigate = useNavigate();
	return <BatteryLogAll {...props} navigate={navigate} />;
}

